export abstract class ButtonLikeAbstraction {
  loading: boolean;
  disabled: boolean;
}
